// extracted by mini-css-extract-plugin
export default {"card":"z8p8zKddgl8Wsb_MxiEE","container":"NE0LUA8cYdYaQUre7fsn","objects":"C2XbJB_I8lsbLQTNAovj","objectPill":"_gSthCKozjQekhRniFY8","content":"acMv0q0Vm0QIv0eB6SnC"};